/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Принять все",
      "Для того, чтобы наш сайт работал лучше, мы используем файлы cookie, в том числе аналитические и рекламные. Ты можешь узнать больше, ознакомившись с нашей <a p0>Политикой использования файлов cookie</a>.",
      "Изменить настройки",
      "Как насчет cookies?",
      "Политика использования файлов cookie",
      "Настройки cookie",
      "(откроется в новом окне)",
      "Навигационная цепочка",
      "Главная",
      "Футер сайта",
      "© Bumble, {{current_year}}. Все права защищены",
      "Зарегистрироваться",
      "Скачать приложение",
      "Помощь",
      "Пресса",
      "Конфиденциальность",
      "Условия",
      "Домашняя страница {{partner}}",
      "При поддержке Bumble Inc",
      "О нас",
      "Блог",
      "Вакансии",
      "Основное",
      "Facebook",
      "Подпи­саться",
      "Instagram",
      "Twitter",
      "Если ты когда-нибудь почувствуешь себя некомфортно, столкнёшься с токсичным поведением или просто захочешь поговорить, мы будем рядом. Ты всегда можешь найти ответы на самые важные вопросы в разделе практических советов.",
      "Домашняя страница Safety Centre {{partner}}",
      "Твоя безопасность всегда на первом месте",
      "Добро пожаловать в Safety Centre, посмотреть видео",
      "Больше советов",
      "Закрыть меню",
      "Советы",
      "К предыдущим контактам",
      "Больше контактов",
      "Контакты",
      "Главная",
      "Меню",
      "Открыть меню",
      "Инструменты",
      "Новости",
      "Вернуться назад",
      "Попробуй обновить браузер или просто вернись на главную страницу.",
      "Страница не найдена :(",
      "По-прежнему нужна помощь?",
      "Используй другое ключевое слово или <a href=\"{{feedback_url}}\" class=\"link\">свяжись с нами</a>.",
      "Проверь, нет ли в твоём запросе опечаток",
      "Сделай свой запрос менее конкретным",
      "Попробуй использовать для поиска синоним",
      "Не позволяй этому тебя остановить! Вот что ты можешь сделать:",
      "Тебе также может понравиться:",
      "К сожалению, мы ничего не нашли по твоему запросу.",
      "Результаты поиска",
      "Результаты по запросу «{{search_query}}»",
      "Очистить поиск",
      "Как мы можем помочь?",
      "Поиск",
      "Bumble не приемлет токсичной атмосферы, оскорблений и грубости. Мы серьёзно относимся к жалобам на токсичное поведение и тщательно разбираем каждую из них.",
      "Мы стремимся защитить тебя и наше сообщество. Если тебе по какой-то причине не по себе, обязательно сообщи об этом, и мы примем необходимые меры.",
      "Непрошеный контент сексуального характера – это не норма. В целях твоей защиты мы размываем потенциально откровенные фото и предупреждаем тебя о них.",
      "Поддельные профили используются для того, чтобы притвориться кем-то другим и обманывать людей онлайн. Если тебе нужна помощь, мы рядом.",
      "Домогательства могут иметь как сексуальный, так и иной подтекст. Если ты подвергаешься домогательствам на Bumble или в реальной жизни, сообщи нам.",
      "Собираешься на свидание? Отлично! Мы заботимся о твоей безопасности и на Bumble, и в реальной жизни, поэтому с радостью поможем подготовиться к встрече.",
      "За время пандемии на смену реальному общению пришло виртуальное. Рассказываем, как безопасно вернуться к встречам в реальной жизни.",
      "Первые свидания – это прекрасно. Легкая неловкость допускается, а вот ощущение опасности – точно нет. Эти советы помогут провести время приятно и безопасно.",
      "Мы знаем, что первые шаги в дейтинге (или возвращение после перерыва) требуют немалых усилий. Мы поддержим тебя на этом пути и поможем быстрее освоиться.",
      "Иногда дейтинг заставляет нас чувствовать себя опустошёнными и уставшими. Дейтинг-выгорание – это нормальное и очень распространённое явление.",
      "Когда предают доверие онлайн, это ранит не меньше реального предательства. Мы знаем, как преодолеть этот неприятный опыт.",
      "У нас есть отличный ободряющий список советов для тех, кто столкнулся с чувством отверженности.",
      "На Bumble можно быть собой, ничего не бояться и отлично проводить время. Мы желаем всем безопасного дейтинга и всегда готовы помочь советом.",
      "Верификация позволяет потенциальным симпатиям понять, что ты – это ты. Узнать о верификации подробнее можно здесь. Весь процесс занимает всего несколько минут.",
      "Обман в дейтинге – вполне реальная угроза. Внимательно относись к тому, какой информацией делишься. Наши советы помогут не стать жертвой мошенников.",
      "Любое действие сексуального характера требует предварительного согласия, которое подразумевает, что вы оба четко и добровольно соглашаетесь на участие в нём.",
      "Мы знаем, что отправить первое сообщение – задача не из простых. Наши советы помогут тебе блестяще с ней справиться.",
      "Наш Центр безопасности Bumble был создан, чтобы помочь вам защитить себя во время знакомств и свиданий. Подробнее: руководства, инструменты, поддержка.",
      "Токсичное поведение | Safety Centre - Bumble",
      "Что происходит после отправки жалобы | Safety Centre - Bumble",
      "Мне прислали откровенное фото | Safety Centre - Bumble",
      "Поддельные профили | Safety Centre - Bumble",
      "Как реагировать на домогательства | Safety Centre - Bumble",
      "Встреча в реальной жизни | Safety Centre - Bumble",
      "Дейтинг и Covid | Safety Centre - Bumble",
      "Безопасность на свидании | Safety Centre - Bumble",
      "Душевное равновесие | Safety Centre - Bumble",
      "Дейтинг-выгорание и как с ним бороться | Safety Centre - Bumble",
      "Моё доверие обманули | Safety Centre - Bumble",
      "Мой профиль привлекает мало внимания | Safety Centre - Bumble",
      "Безопасный дейтинг | Safety Centre - Bumble",
      "Как работает верификация | Safety Centre - Bumble",
      "Как не стать жертвой обмана | Safety Centre - Bumble",
      "Как спрашивать и давать согласие | Safety Centre - Bumble",
      "Как начать разговор | Safety Centre - Bumble",
      "Центр безопасности онлайн-знакомств | Bumble",
      "Скачать в App Store",
      "Скачать в Google Play",
      "Закрыть раздел",
      "Закрыть",
      "Показать больше",
      "Эти инструменты разработаны для того, чтобы защитить тебя на всех этапах общения онлайн. Узнай, как сделать знакомства на Bumble ещё приятнее.",
      "Больше советов от экспертов дейтинга, а также самые последние новости о тенденциях в отношениях – в нашем блоге.",
      "Наш справочник по безопасности",
      "Выбор языка"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "few": [
                  "дня",
                  "дней",
                  "дням",
                  "дня",
                  "днями",
                  "днях"
            ],
            "many": [
                  "дней",
                  "дней",
                  "дням",
                  "дней",
                  "днями",
                  "днях"
            ],
            "plural": [
                  "дня",
                  "дней",
                  "дням",
                  "дня",
                  "днями",
                  "днях"
            ],
            "singular": [
                  "день",
                  "дня",
                  "дню",
                  "день",
                  "днём",
                  "дне"
            ],
            "two": [
                  "дня",
                  "дней",
                  "дням",
                  "дня",
                  "днями",
                  "днях"
            ]
      },
      "hour": {
            "few": [
                  "часа",
                  "часов",
                  "часам",
                  "часа",
                  "часами",
                  "часах"
            ],
            "many": [
                  "часов",
                  "часов",
                  "часам",
                  "часов",
                  "часами",
                  "часах"
            ],
            "plural": [
                  "часа",
                  "часов",
                  "часам",
                  "часа",
                  "часами",
                  "часах"
            ],
            "singular": [
                  "час",
                  "часа",
                  "часу",
                  "час",
                  "часом",
                  "часе"
            ],
            "two": [
                  "часа",
                  "часов",
                  "часам",
                  "часа",
                  "часами",
                  "часах"
            ]
      },
      "minute": {
            "few": [
                  "минуты",
                  "минут",
                  "минутам",
                  "минуты",
                  "минутами",
                  "минутах"
            ],
            "many": [
                  "минут",
                  "минут",
                  "минутам",
                  "минут",
                  "минутами",
                  "минутах"
            ],
            "plural": [
                  "минуты",
                  "минут",
                  "минутам",
                  "минуты",
                  "минутами",
                  "минутах"
            ],
            "singular": [
                  "минута",
                  "минуты",
                  "минуте",
                  "минуту",
                  "минутой",
                  "минуте"
            ],
            "two": [
                  "минуты",
                  "минут",
                  "минутам",
                  "минуты",
                  "минутами",
                  "минутах"
            ]
      },
      "month": {
            "few": [
                  "месяца",
                  "месяцев",
                  "месяца",
                  "месяца",
                  "месяцами",
                  "месяцах"
            ],
            "many": [
                  "месяцев",
                  "месяцев",
                  "месяцев",
                  "месяцев",
                  "месяцами",
                  "месяцах"
            ],
            "plural": [
                  "месяца",
                  "месяцев",
                  "месяца",
                  "месяца",
                  "месяцами",
                  "месяцах"
            ],
            "singular": [
                  "месяц",
                  "месяца",
                  "месяц",
                  "месяц",
                  "месяцем",
                  "месяце"
            ],
            "two": [
                  "месяца",
                  "месяцев",
                  "месяца",
                  "месяца",
                  "месяцами",
                  "месяцах"
            ]
      },
      "second": {
            "few": [
                  "секунды",
                  "секунд",
                  "секундам",
                  "секунды",
                  "секундами",
                  "секундах"
            ],
            "many": [
                  "секунд",
                  "секунд",
                  "секундам",
                  "секунд",
                  "секундами",
                  "секундах"
            ],
            "plural": [
                  "секунды",
                  "секунд",
                  "секундам",
                  "секунды",
                  "секундами",
                  "секундах"
            ],
            "singular": [
                  "секунда",
                  "секунды",
                  "секунде",
                  "секунду",
                  "секундой",
                  "секунде"
            ],
            "two": [
                  "секунды",
                  "секунд",
                  "секундам",
                  "секунды",
                  "секундами",
                  "секундах"
            ]
      },
      "year": {
            "few": [
                  "года",
                  "лет",
                  "годам",
                  "года",
                  "годами",
                  "годах"
            ],
            "many": [
                  "лет",
                  "лет",
                  "годам",
                  "лет",
                  "годами",
                  "годах"
            ],
            "plural": [
                  "года",
                  "лет",
                  "годам",
                  "года",
                  "годами",
                  "годах"
            ],
            "singular": [
                  "год",
                  "года",
                  "году",
                  "год",
                  "годом",
                  "годе"
            ],
            "two": [
                  "года",
                  "лет",
                  "годам",
                  "года",
                  "годами",
                  "годах"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
